import { HorizontalFlex } from '@eversports/react-components/primitives/Flex'
import MenuItem from '@eversports/react-components/primitives/MenuItem'
import Select from '@eversports/react-components/primitives/Select'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'
import styled from 'styled-components'

import getCountryCallingCodes, { CountryCallingCode } from './get-country-calling-codes'
import PhoneNumberFieldCountryCallingCodeIcon from './PhoneNumberFieldCountryCallingCodeIcon'

const StyledHorizontalFlex = styled(HorizontalFlex).withConfig({
  shouldForwardProp: (prop) => !['horizontalSpacing', 'alignItems'].includes(prop),
})`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  gap: ${({ horizontalSpacing }) => (horizontalSpacing === 'dense' ? '8px' : '16px')};
`

const PhoneNumberFieldCountryCallingCodes: React.FC<React.PropsWithChildren<unknown>> = () => {
  const countryCallingCodes: Array<CountryCallingCode> = getCountryCallingCodes()
  return (
    <Select name="countryCallingCode" required>
      {countryCallingCodes.map(({ country, code }) => (
        <MenuItem key={country} value={code}>
          <StyledHorizontalFlex horizontalSpacing="dense" alignItems="center">
            <PhoneNumberFieldCountryCallingCodeIcon country={country} />
            <Text size="small">{code}</Text>
          </StyledHorizontalFlex>
        </MenuItem>
      ))}
    </Select>
  )
}

export default PhoneNumberFieldCountryCallingCodes
